/**
* Created by: cparaschiv
* Date: 23.01.2013, 16:21
*/

ko.bindingHandlers['anchor-enable'] = {
    'update': function (element, valueAccessor) {
        var value = TS.unwrap(valueAccessor());
        if (value && element.disabled)
            element.removeAttribute("disabled");
        else if ((!value) && (!element.disabled))
            element.disabled = true;
    }
};

ko.bindingHandlers['kendo_enable'] = {

    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

        var isEnabled = TS.unwrap(valueAccessor()),
            input,
            dataBind,
            isBrowser = false,
            isLookup = false;

        ko.applyBindingsToDescendants(bindingContext, element);

        input = $(element).find('input[data-role]').first();

        // set DOM element attributes, widget will infer state from them
        if (input && !isEnabled) {
            dataBind = input.attr('data-bind');
            if (dataBind) {
                isBrowser = (dataBind.indexOf('kendoTsBrowsePicker') > -1);
                isLookup = (dataBind.indexOf('kendoTsLateFetchCombo') > -1);
            }

            if (isBrowser || isLookup) {
                input.attr('disabled', 'disabled');
            }
        }
        return { controlsDescendantBindings: true };
    },

    update: function (element, valueAccessor) {

        var isEnabled = TS.unwrap(valueAccessor()),
            input,
            handler;

        // find input element that has a data role
        // that's the one holding a reference to the actual widget instance (handler)
        input = $(element).find('input[data-role]').first();

        if (input && input.data && input.data()) {
            handler = input.data().handler;
            if (handler && handler.enable)
                handler.enable(isEnabled);
        }
    }
};

ko.bindingHandlers['kendo_readOnly'] = {

    init: function (element, valueAccessor) {

        var isReadOnly = TS.unwrap(valueAccessor()),
            input,
            dataBind,
            isBrowser = false;

        // set DOM element attributes, widget will infer state from them
        input = $(element).find('input').first();
        if (input && isReadOnly) {
            dataBind = input.attr('data-bind');
            if (dataBind && dataBind.indexOf('kendoTsBrowsePicker') > -1) {
                isBrowser = true;
            }

            if (isBrowser) {
                input.attr('readonly', 'readonly');
            }
        }
    },

    update: function (element, valueAccessor) {

        var isReadOnly = TS.unwrap(valueAccessor()),
            input,
            handler;

        // find input element that has a data role
        // that's the one holding a reference to the actual widget instance (handler)
        input = $(element).find('input[data-role]').first();

        if (input && input.data && input.data()) {
            handler = input.data().handler;
            if (handler && handler.readonly)
                handler.readonly(isReadOnly);
        }
    }
};


ko.bindingHandlers['url'] = {
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $elem = $(element),
            cfg;

        cfg = function () { return { href: TS.unwrap(valueAccessor()) } };
        ko.bindingHandlers["attr"].update(element, cfg, allBindings, viewModel, bindingContext);
    }
};

ko.bindingHandlers['breadcrumb_activeIndex'] = {
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $elem = $(element),
            index = TS.unwrap(valueAccessor());

        $elem.find('a').removeClass('current');
        $elem.find('a').attr('href', '#');
        $($elem.find('a')[index]).addClass('current');
        $($elem.find('a')[index]).removeAttr('href');
    }
};

ko.bindingHandlers['formatText'] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $elem = $(element),
            options = TS.unwrap(valueAccessor()),
            value, member,
            method = options.method || 'text';

        value = TS.Util.getProperty(bindingContext.$data, TS.unwrap(options.data));
        if (options.hasOwnProperty('type') && options.type == 'boolean') {
            value = !!value;
        }

        if (options.hasOwnProperty('member') && value != null) {
            if (value[options.member] && ko.valueOf(value[options.member]))
                value = TS.Util.getProperty(bindingContext.$data,  ko.valueOf(value[options.member]));
        }

        if (value === null)
            value = '-';
        if (value === true) {
            value = '<i class="fa fa-check-square-o"></i>';
            method = 'html';
        }
        else if (value === false) {
            value = '<i class="fa fa-square-o"></i>';
            method = 'html';
        }
        else
            if (options.hasOwnProperty('type') && options.type == 'date' && value !== '')
                value = kendo.toString(kendo.parseDate(value), options.format);
            else
                value = kendo.toString(value, options.format);

        $elem[method](value);
    }
};

ko.bindingHandlers['tsSelectionListText'] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $elem = $(element),
            options = TS.unwrap(valueAccessor()),
            value, member,
            method = options.method || 'text';
        ;
       
        if (options.selectionListName) {
            var selectionList = TS.getPropertyValue(bindingContext.$data, options.selectionListName);
            if (selectionList) {
                if (options.showEditMember) {
                    value = TS.accessor(selectionList.Domain(), TS.unwrap(selectionList.EditMember)).value;
                }
                else {
                    value = TS.accessor(selectionList.Domain(), TS.unwrap(selectionList.DisplayMember)).value;
                }
            }
        }

        if (value === null)
            value = '-';

        $elem[method](TS.unwrap(value));
    }
};

ko.bindingHandlers['tsExpandableText'] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $elem = $(element),
            $parent,
            $more, $less, $text,
            maxHeight, minHeight,
            animDuration = 200;

        $parent = $elem.parent();
        $less = $parent.find(".ts-exp-less");
        $more = $parent.find(".ts-exp-more");
        $text = $parent.find('.ts-exp-text');
        minHeight = $text.height() + "px";

        $more.click(function () {
            maxHeight = $text.get(0).scrollHeight;
            $(this).animate({ 'opacity': '0' }, animDuration);
            $less.animate({
                'opacity': '1',
                'z-index': '1'
            }, animDuration);
            $text.animate({ 'height': maxHeight }, animDuration);
        });
        $less.click(function () {
            $(this).animate({
                'opacity': '0',
                'z-index': '-1'
            }, animDuration);
            $more.animate({ 'opacity': '1' }, animDuration);
            $text.animate({ 'height': minHeight }, animDuration);
        });
    },

    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        ko.bindingHandlers['html'].update.call(this, element, valueAccessor, allBindings, viewModel, bindingContext);
    }
};

ko.bindingHandlers['tsExpandableSection'] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $parent, props, prop;

        $parent = $(element).parent();
        prop = TS.Util.getProperty(viewModel, valueAccessor(), true);

        $parent.click(function () {
            prop(!TS.unwrap(prop));
        });
    },

    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $elem, $parent, props, prop,
            collapsed = "icon-collapse", expanded = "icon-expand";

        prop = TS.Util.getProperty(viewModel, valueAccessor(), true);
        $elem = $(element);

        $elem.removeClass(!prop() ? collapsed : expanded).addClass(prop() ? collapsed : expanded);
    }
};

(function () {

    var fixHtml = function (html) {
        return html && html.replace(new RegExp('<\\\\/', 'g'), '</');
    }

    /*
        Used to fix the issue regarding serialization method TS.App.Web.Adapters.BaseAdapter.WriteScalar 
        which (in case of strings) replaces  "</" with "<\\/" (2 slashes instead of 1) and breaks the html
    */
    ko.bindingHandlers['tsHtml'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            return ko.bindingHandlers['html'].init(element, valueAccessor, allBindings, viewModel, bindingContext);
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var wrapp = function () {
                var v = valueAccessor();
                var vUnwrapped = ko.unwrap(v);
                if (vUnwrapped === undefined || vUnwrapped == null)
                    return vUnwrapped;
                return fixHtml(vUnwrapped);
            }
            ko.bindingHandlers['html'].update(element, wrapp, allBindings, viewModel, bindingContext);
        }
    };

    ko.bindingHandlers['tsKendoEditor'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var me = this,
                el = $(element),
                editor;

            el.kendoEditor({ resizable: true });

            editor = el.data('kendoEditor');
            editor.bind('change', function () {
                valueAccessor().value(this.value());
            });
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var config = valueAccessor(),
                value = ko.unwrap(config.value),
                el = $(element),
                editor = el.data('kendoEditor');
            $(editor.body).html(fixHtml(value));
            editor.update();
        }
    };
})();



ko.bindingHandlers['3StateChecked'] = {
    'after': ['value', 'attr'],
    'init': function (element, valueAccessor, allBindings) {

        function updateModel() {
            // This updates the model value from the view value.
            // It runs in response to DOM events (click) and changes in checkedValue.
            var isChecked = element.checked;

            // When we're first setting up this computed, don't change any model state.
            if (ko.computedContext.isInitial()) {
                return;
            }

            var modelValue = ko.dependencyDetection.ignore(valueAccessor);
            if (isValueArray) {
                if (oldElemValue !== elemValue) {
                    // When we're responding to the checkedValue changing, and the element is
                    // currently checked, replace the old elem value with the new elem value
                    // in the model array.
                    if (isChecked) {
                        ko.utils.addOrRemoveItem(modelValue, elemValue, true);
                        ko.utils.addOrRemoveItem(modelValue, oldElemValue, false);
                    }

                    oldElemValue = elemValue;
                } else {
                    // When we're responding to the user having checked/unchecked a checkbox,
                    // add/remove the element value to the model array.
                    ko.utils.addOrRemoveItem(modelValue, elemValue, isChecked);
                }
            } else {
                ko.expressionRewriting.writeValueToProperty(modelValue, allBindings, 'checked', elemValue, true);
            }
        };

        function updateView() {
            // This updates the view value from the model value.
            // It runs in response to changes in the bound (checked) value.
            var modelValue = ko.utils.unwrapObservable(valueAccessor());

            if (isValueArray) {
                // When a checkbox is bound to an array, being checked represents its value being present in that array
                element.checked = ko.utils.arrayIndexOf(modelValue, checkedValue()) >= 0;
            } else if (isCheckbox) {
                // When a checkbox is bound to any other value (not an array), being checked represents the value being trueish
                element.checked = modelValue;
            } else {
                // For radio buttons, being checked means that the radio button's value corresponds to the model value
                element.checked = (checkedValue() === modelValue);
            }
        };

        var isCheckbox = element.type == "checkbox";

        // Only bind to check boxes
        if (!isCheckbox) {
            return;
        }

        // The first responds to changes in the checkedValue value and to element clicks
        ko.computed(updateModel, null, { disposeWhenNodeIsRemoved: element });
        ko.utils.registerEventHandler(element, "click", updateModel);

        // The second responds to changes in the model value (the one associated with the checked binding)
        ko.computed(updateView, null, { disposeWhenNodeIsRemoved: element });
    }
};
ko.expressionRewriting.twoWayBindings['3StateChecked'] = true;

ko.bindingHandlers['tsMergeControl'] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $element = $(element), values = TS.unwrap(valueAccessor()), readOnly = TS.unwrap(values.readOnly),
            rightSideText = TS.unwrap(values.rightSideText), leftSideText = TS.unwrap(values.leftSideText),
            editorHeight = TS.unwrap(values.editorHeight);

        $element.mergely({
            editor_height: editorHeight,
            editor_width: '48%',
            cmsettings: { readOnly: readOnly, lineNumbers: true },
            lhs: function (setValue) {
                if (leftSideText === undefined || leftSideText === null)
                    setValue('');
                else
                    setValue(leftSideText);
            },
            rhs: function (setValue) {
                if (rightSideText === undefined || rightSideText === null)
                    setValue('');
                else
                    setValue(rightSideText);
            }
        });
    }
};


ko.bindingHandlers['tsVisible'] = {
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var $elem = $(element),
            $parent,
            $children,
            isVisible,
            firstVisible;

        ko.bindingHandlers['visible'].update.apply(this, arguments);

        isVisible = TS.unwrap(valueAccessor());

        var wrapper = $elem.closest('[data-role=wrapper]');
        if (wrapper) {
            if (isVisible)
                wrapper.show();
            else wrapper.hide();
        }

        $parent = $elem.closest('.row-fluid');
        $children = $parent.children('div');
        $children.removeClass('first-visible');

        firstVisible = $children.filter(':visible').first();
        firstVisible.addClass('first-visible');

        if (isVisible === true) {
            // trigger resize event, if a div contains a kendo-grid created when the div was hidden, when the div is shown the grid doesn't do layout.
            $elem.trigger('resize');
        }
    }
};

ko.bindingHandlers['tsEnable'] = {
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var value = TS.unwrap(valueAccessor());

        ko.bindingHandlers['enable'].update.apply(this, arguments);

        if (value && element.hasChildNodes()) {
            $(element).find("*").removeAttr('disabled', 'disabled');
        }
        else if (!value && element.hasChildNodes()) {
            $(element).find("*").attr('disabled', 'disabled');
        }
    }
};

ko.bindingHandlers['tsReadOnly'] = {
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var value = TS.unwrap(valueAccessor());

        if ((!value)) {
            $(element).removeAttr('readonly', 'readonly');
            if (element.hasChildNodes())
                $(element).find("*").removeAttr('readonly', 'readonly');
        }
        else if (value) {
            $(element).attr('readonly', 'readonly');
            if (element.hasChildNodes())
                $(element).find("*").attr('readonly', 'readonly');
        }
    }
};

ko.bindingHandlers.placeholder = {
    update: function (element, valueAccessor) {
        ko.bindingHandlers.attr.update(element, function () { return { placeholder: valueAccessor() }; });
    }
};